import developerRegistration from './developerRegistration';

export const developerOnboardingStore = developerRegistration;
